
import React from 'react';

const Map = (props: any) => {
    // const [center, setCenter] = useState({lat: 39.98902860303093, lng: 32.750475149376975 });
const myStyle = {
    border:0
    } as React.CSSProperties;


    return (
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9428.823383170566!2d32.74419915610201!3d39.98794554392566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d34988600137db%3A0x2cff3e50e6c1767!2sAydin%20Transformer-Coil!5e0!3m2!1sen!2sus!4v1609046447114!5m2!1sen!2sus" width="600" height="450" style={myStyle} aria-hidden="false"></iframe>
    )
}

export default Map;